// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.remove-coupon-modal-wrapper {
  padding: 20px !important;
  width: 90%;
  max-width: 360px;
}
.remove-coupon-modal-wrapper .remove-coupon-modal-body-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 28px;
}
.remove-coupon-modal-wrapper .remove-coupon-modal-body-wrapper h5 {
  margin: 0;
  text-align: center;
  line-height: 28px;
}
.remove-coupon-modal-wrapper .remove-coupon-modal-body-wrapper h5 em {
  color: #00AA44;
}
.remove-coupon-modal-wrapper .remove-coupon-modal-body-wrapper .remove-coupon-button-wrapper {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 16px;
  margin-top: 4px;
}
.remove-coupon-modal-wrapper .remove-coupon-modal-body-wrapper .remove-coupon-button-wrapper button {
  width: 100%;
  white-space: nowrap;
  padding: 8px 16px;
  border-radius: 4px;
  border: 1px solid #ddd;
  font-weight: 500;
}
.remove-coupon-modal-wrapper .remove-coupon-modal-body-wrapper .remove-coupon-button-wrapper button:first-child {
  background-color: #93288E;
  border: none;
  color: #fff;
}`, "",{"version":3,"sources":["webpack://./src/pages/PublicPaymentPage/components/PublicModalWrapper/RemoveCouponModal/style.scss"],"names":[],"mappings":"AAAA;EACI,wBAAA;EACA,UAAA;EACA,gBAAA;AACJ;AACI;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;AACR;AACQ;EACI,SAAA;EACA,kBAAA;EACA,iBAAA;AACZ;AACY;EACI,cAAA;AAChB;AAGQ;EACI,WAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;AADZ;AAGY;EACI,WAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,gBAAA;AADhB;AAIY;EACI,yBAAA;EACA,YAAA;EACA,WAAA;AAFhB","sourcesContent":[".remove-coupon-modal-wrapper{\n    padding: 20px!important;\n    width: 90%;\n    max-width: 360px;\n\n    .remove-coupon-modal-body-wrapper{\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        align-items: center;\n        gap: 28px;\n\n        h5{\n            margin: 0;\n            text-align: center;\n            line-height: 28px;\n\n            em{\n                color: #00AA44;\n            }\n        }\n\n        .remove-coupon-button-wrapper{\n            width: 100%;\n            display: flex;\n            flex-wrap: wrap;\n            justify-content: center;\n            align-items: center;\n            gap: 16px;\n            margin-top: 4px;\n\n            button{\n                width: 100%;\n                white-space: nowrap;\n                padding: 8px 16px;\n                border-radius: 4px;\n                border: 1px solid #ddd;\n                font-weight: 500;\n            }\n\n            button:first-child{\n                background-color: #93288E;\n                border: none;\n                color: #fff;\n            }\n        }\n    }\n}\n    "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
